import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import EastOutlined from '@mui/icons-material/EastOutlined';
import { SxProps, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { t } from 'i18next';
import React from 'react';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Project } from '~hooks/useProjects/models';

import { FlexColumn, FlexRow } from '../../styled';

interface DatesProps {
  project: Project;
  sx?: SxProps<Theme>;
}

export default function Dates({ project, sx }: DatesProps) {
  const nodes: React.ReactNode[] = [];

  if (project.effectiveAt) {
    nodes.push(
      <Typography component="span" sx={{ color: 'inherit', fontSize: 'inherit' }}>
        {dayjs.tz(project.effectiveAt).format('MMM-DD-YYYY')}
      </Typography>,
    );
  }

  if (project.expiresAt) {
    nodes.push(
      <Typography component="span" sx={{ color: 'inherit', fontSize: 'inherit' }}>
        {dayjs.tz(project.expiresAt).format('MMM-DD-YYYY')}
      </Typography>,
    );
  }

  return (
    <FlexRow sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <CalendarMonthOutlined
        sx={(theme) => ({ color: theme.brandV2.colors.treadBlack, fontSize: '20px' })}
      />

      <FlexColumn sx={{ gap: 0, flex: 1 }}>
        <OverflowAwareText>
          {nodes.map((node, index) => (
            <React.Fragment key={index}>
              {node}

              {nodes.length - 1 !== index && (
                <EastOutlined
                  sx={(theme) => ({
                    color: theme.brandV2.colors.treadBlack,
                    fontSize: '12px',
                    mb: '2px',
                    mx: 0.5,
                  })}
                />
              )}
            </React.Fragment>
          ))}
        </OverflowAwareText>

        <OverflowAwareText
          sx={(theme) => ({ color: theme.brandV2.colors.treadGray3, fontSize: '10px' })}
        >
          {`${t('dispatch.order.created_at')}: ${dayjs(project.createdAt).tz().format('MMM-DD-YYYY')}`}
        </OverflowAwareText>
      </FlexColumn>
    </FlexRow>
  );
}
